<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            :loading-text="tableLoadingText"
            ajax-path="rhipe/contract-agreements"
        />
    </div>
</template>

<script>
    import Http from '@/helpers/Http';

    export default {
        data() {
            return {
                refreshTable: false,
                tableIsLoading: false,
                tableLoadingText: null,
                columns: [
                    {
                        title: 'Program Name',
                        field: 'ProgramName',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Start Date',
                        field: 'StartDateForHuman',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Status', 
                        field: 'IsActive', 
                        minWidth: 130,
                        formatter({_cell}, params) {
                            if (_cell.value) {
                                return `<span class='badge badge-green'>Active</span>`;
                            }

                            return `<span class='badge badge-red'>Inactive</span>`;
                        }
                    },
                ],
                actions: [
                    {
                        label: 'Sync',
                        icon: () => import('@/icons/Sync.vue'),
                        handler: this.sync
                    },
                ],
            }
        },
        methods: {
            sync() {
                this.tableIsLoading = true;
                this.tableLoadingText = 'Syncing...';
                Http.patch('rhipe/contract-agreements/sync')
                    .then(() => {
                        this.tableIsLoading = false;
                        this.refreshTable = true;
                    })
                    .catch(() => {
                        this.tableIsLoading = false;
                    });
            }
        }
    }
</script>